<!-- @see https://schema.org/Product -->
<meta itemscope itemprop="mainEntityOfPage" itemType="https://schema.org/WebPage" [attr.itemid]="collectionUrl"/>

<meta itemprop="url" content="{{ collectionUrl }}"/>
<meta itemprop="name" content="{{ fullTitle }}"/>
<meta itemprop="image" content="{{ metaImageUrl }}"/>
<meta itemprop="material" content="{{ collection?.stats?.total }}">
<meta itemprop="gtin" content="">
<meta *ngIf="collection.description" itemprop="description" content="{{ collection.description | striptags }}"/>

<div itemprop="offers" itemscope itemtype="https://schema.org/Offer">
  <span itemprop="priceCurrency" content="USD"></span>
  <meta itemprop="price" content="{{ price_tier_personal }}"/>
  <meta itemprop="priceValidUntil" content="{{ price_valid_until }}"/>
  <link itemprop="availability" href="https://schema.org/InStock" />
</div>
<div itemprop="offers" itemscope itemtype="https://schema.org/Offer">
  <span itemprop="priceCurrency" content="USD"></span>
  <meta itemprop="price" content="{{ price_tier_professional }}"/>
  <meta itemprop="priceValidUntil" content="{{ price_valid_until }}"/>
  <link itemprop="availability" href="https://schema.org/InStock" />
</div>
<div itemprop="offers" itemscope itemtype="https://schema.org/Offer">
  <span itemprop="priceCurrency" content="USD"></span>
  <meta itemprop="price" content="{{ price_tier_business }}"/>
  <meta itemprop="priceValidUntil" content="{{ price_valid_until }}"/>
  <link itemprop="availability" href="https://schema.org/InStock" />
</div>
<div itemprop="aggregateRating" itemscope itemtype="https://schema.org/AggregateRating">
  <meta itemprop="reviewCount" content="{{ collection?.stats?.reviews_count }}"/>
  <meta itemprop="ratingValue" content="{{ collection?.stats?.rating }}"/>
  <meta itemprop="bestRating" content="{{ collection?.stats?.rating }}"/>
</div>
